import { useOutletContext } from "react-router-dom";
//old import { LayoutDashboard, Layers, Users, KeyRound, UserCog, Settings } from "lucide-react";
//old import { LayoutDashboard, Layers, Users, KeyRound, UserCog, Settings, ListChecks } from "lucide-react";
import { LayoutDashboard, Layers, Users, KeyRound, UserCog, Settings, ListChecks, MessageSquare, BarChart3 } from "lucide-react";

/** Pages of the organization portal; each is its own route under /org. */
export const ORG_PAGES = [
    { key: "overview", path: "", label: "Overview", icon: LayoutDashboard },
    { key: "programs", path: "programs", label: "Programs", icon: Layers },
    //old { key: "students", path: "students", label: "Students", icon: Users },
    // the page is Clients now (JJ, Nov 2); its key and path stay "students", the routes and links use them
    { key: "students", path: "students", label: "Clients", icon: Users },
    { key: "licenses", path: "licenses", label: "Licenses", icon: KeyRound, adminOnly: true },
    { key: "scoring", path: "scoring", label: "Checklists & Scoring", icon: ListChecks, adminOnly: true },
    { key: "staff", path: "staff", label: "Coaches & Admins", icon: UserCog, adminOnly: true },
    { key: "settings", path: "settings", label: "Settings", icon: Settings, adminOnly: true },
    { key: "requests", path: "requests", label: "Requests", icon: MessageSquare, adminOnly: true },
    // Grant reporting (Alicia, Oct 16)
    { key: "impact", path: "impact", label: "Impact report", icon: BarChart3, adminOnly: true },
];

/** How the portal's menus group those pages (Evan, Oct 16): Overview (and the
 *  impact report) on their own, then Users, Programs & Checklists, Licenses, and
 *  General (requests with settings). */
export const ORG_PAGE_GROUPS = [
    { key: "top", label: null, pages: ["overview", "impact"] },
    { key: "users", label: "Users", pages: ["students", "staff"] },
    { key: "programs", label: "Programs & Checklists", pages: ["programs", "scoring"] },
    { key: "licenses", label: "Licenses", pages: ["licenses"] },
    { key: "general", label: "General", pages: ["requests", "settings"] },
];

/** The given pages (the ones this viewer can open) in their menu groups, in group
 *  order; groups left empty are dropped. Both the sidebar and the portal's page links
 *  use this, so they can't drift apart, and a page missing from ORG_PAGE_GROUPS still
 *  shows up at the end instead of disappearing from the menus. */
export function groupedOrgPages(pages) {
    const groups = ORG_PAGE_GROUPS
        .map((g) => ({ ...g, pages: g.pages.map((key) => pages.find((p) => p.key === key)).filter(Boolean) }))
        .filter((g) => g.pages.length);
    const grouped = new Set(ORG_PAGE_GROUPS.flatMap((g) => g.pages));
    const rest = pages.filter((p) => !grouped.has(p.key));
    return rest.length ? [...groups, { key: "more", label: null, pages: rest }] : groups;
}

/** URL for an org page, keeping ?orgId= when the viewer picked a specific org. */
export function orgPagePath(key, { orgId, ...extra } = {}) {
    const page = ORG_PAGES.find((p) => p.key === key) || ORG_PAGES[0];
    const params = new URLSearchParams();
    if (orgId) params.set("orgId", orgId);
    Object.entries(extra).forEach(([k, v]) => { if (v) params.set(k, v); });
    const qs = params.toString();
    return `/org${page.path ? `/${page.path}` : ""}${qs ? `?${qs}` : ""}`;
}

/**
 * Shared state OrgLayout hands to every org page:
 * { orgId, org, viewer, isOrgAdmin, isPlatformAdmin, reloadOrg, goTo(key, extraParams) }
 */
export const useOrgPortal = () => useOutletContext();
